import { getDragCustomerName } from '@/pages/sale/lib/sale-comment-drag';
import { OrderResponse } from '@/types/order-type';
import { WsEvent } from '@/types/ws-type';
import { DROP_SLOT_ROW_HEIGHT } from './pinned-board-constants';

export function createOptimisticOrder(
  payload: Record<string, unknown>,
  unitPrice: number,
): OrderResponse {
  return {
    id: `optimistic-${Date.now()}`,
    customerId: '',
    status: 'CONFIRMED' as OrderResponse['status'],
    subTotal: 0,
    source: 'FACEBOOK',
    orderNumber: '…',
    deliveryStatus: 'PENDING',
    customerName: getDragCustomerName(payload),
    totalItems: 1,
    totalAmount: unitPrice,
    createdAt: new Date().toISOString(),
  };
}

export function parseWsEvent(body: string): WsEvent | null {
  try {
    return JSON.parse(body) as WsEvent;
  } catch {
    return null;
  }
}

export function resolveDropSlotFromPointer(args: {
  clientY: number;
  container: HTMLDivElement;
  orderCount: number;
  orderRowsHeight: number;
  nextDropSlotNo: number;
}) {
  const { clientY, container, orderCount, orderRowsHeight, nextDropSlotNo } = args;
  const rect = container.getBoundingClientRect();
  const y = clientY - rect.top + container.scrollTop;

  if (y < orderRowsHeight) return nextDropSlotNo;

  const dropIndex = Math.floor((y - orderRowsHeight) / DROP_SLOT_ROW_HEIGHT);
  const hoveredSlotNo = orderCount + dropIndex + 1;
  return hoveredSlotNo >= nextDropSlotNo ? hoveredSlotNo : nextDropSlotNo;
}
